export default __webpack_public_path__ + "static/media/loader-gradient.18ec93df.svg";